<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          dark
          small
          color="success"
          @click="
            $router.push({
              name: 'Home',
            })
          "
        >
          Menú
        </v-btn>
        <br />
        <br />
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="12"
          xl="12"
          lg="12"
          v-if="active == 0"
        >
          <v-alert prominent type="info">
            Servicio temporalmente inactivo
          </v-alert>
        </v-col>
        <div v-else>
          <v-row>
            <v-col md="12">
              <v-card elevation="0" style="background-color: #eff4f5">
                <v-card-text class="flex-shrink-1" v-if="usuarioBorrado != 1">
                  <div style="position: absolute; top: 50px; z-index: 1000">
                    <VEmojiPicker
                      class="elevation-1"
                      @select="selectEmoji"
                      emojiSize="25"
                      emojisByRow="9"
                      v-if="showEmojis"
                    />
                  </div>

                  <template>
                    <Mentionable
                      :keys="['@', '#']"
                      :items="followings"
                      offset="6"
                      insert-space
                      @search="searchText = $event"
                      @open="openKey = $event"
                      @close="closeKey = $event"
                      @apply="(item, key) => selectItem(item)"
                    >
                      <v-textarea
                        v-model.trim="content"
                        label="¿Qué estas pensando?"
                        type="text"
                        no-details
                        prepend-icon="mdi-emoticon"
                        @click:prepend="showEmojis = !showEmojis"
                        @click="showEmojis = false"
                        @focus="showEmojis = false"
                        hide-details
                        name="input-7-4"
                        rows="3"
                        solo
                      >
                        <template slot="append">
                          <v-icon
                            color="green"
                            @click="uploadFilesEvent()"
                            title="Adjuntar imagen"
                            >mdi-file-image</v-icon
                          >
                          <v-icon
                            color="orange"
                            @click="uploadVideoEvent()"
                            title="Adjuntar video"
                            >mdi-file-video</v-icon
                          >
                        </template>
                      </v-textarea>

                      <template #no-result>
                        <div class="dim">No result</div>
                      </template>

                      <template #item-@="{ item }">
                        <div class="user">
                          <v-avatar size="25" color="#8fc6dc">
                            <v-img
                              :src="item.Avatar"
                              v-if="item.Avatar"
                            ></v-img>
                            <v-icon dark v-else>mdi-image</v-icon>
                          </v-avatar>
                          {{ item.value }}
                        </div>
                      </template>
                    </Mentionable>
                  </template>

                  <input
                    id="file-upload"
                    type="file"
                    @change="onFileChange"
                    ref="fileInput"
                    style="visibility: hidden"
                    multiple=""
                  />
                  <input
                    id="file-upload2"
                    type="file"
                    @change="onVideoChange"
                    ref="fileInputVideo"
                    style="visibility: hidden"
                  />
                  <v-row>
                    <v-chip
                      class="ma-2"
                      close
                      color="#f2f2f2"
                      close-icon="mdi-delete"
                      text-color="blue"
                      v-for="(file, index) in files"
                      :key="index"
                      @click:close="
                        file.id
                          ? deleteFileThumnail(index, file.id)
                          : deleteFileThumnail(index, null)
                      "
                    >
                      <v-sheet
                        color="white"
                        elevation="1"
                        height="100"
                        width="100"
                        class="m-10 p-5 preview"
                      >
                        <img :src="file.image" v-if="file.id" />
                        <img :src="file.url" v-else />
                      </v-sheet>
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      close
                      color="#f2f2f2"
                      close-icon="mdi-delete"
                      text-color="blue"
                      @click:close="video = null"
                      v-if="video"
                    >
                      <v-sheet
                        color="white"
                        elevation="1"
                        height="100"
                        width="100"
                        class="
                          m-10
                          p-5
                          preview
                          d-flex
                          align-center
                          justify-center
                          pa-4
                          mx-auto
                        "
                      >
                        <v-icon x-large color="#095da1" class="mx-auto"
                          >mdi-filmstrip</v-icon
                        >
                      </v-sheet>
                    </v-chip>
                  </v-row>
                </v-card-text>
                <v-card-actions style="padding: 16px" class="pl-12">
                  <v-row dense>
                    <v-col>
                      <v-btn
                        depressed
                        color="primary"
                        @click="addPost()"
                        v-if="action == 'add' && usuarioBorrado!=1"
                      >
                        Publicar
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-btn
                        depressed
                        color="primary"
                        @click="editPost()"
                        v-if="action == 'edit'"
                      >
                        Editar 
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-btn
                        depressed
                        color="danger"
                        @click="cancel()"
                        v-if="action == 'edit'"
                      >
                        Cancelar
                      </v-btn>
                    </v-col>
                      <v-spacer></v-spacer>
                    <v-col>
                      <v-btn
                        depressed
                        color="info"
                        @click="$router.push('profile')"
                        class="ml-lg-5 ml-md-5 ml-0"
                      >
                        <v-avatar
                          size="25"
                          title="Ver perfil"
                          style="cursor: pointer; margin-right: 5%;"
                        >
                          <div
                            class="v-image v-responsive theme--light"
                            v-if="user.imagen"
                          >
                            <div
                              class="v-responsive__sizer"
                              style="padding-bottom: 190.399%"
                            ></div>
                            <div
                              class="v-image__image v-image__image--cover"
                              v-bind:style="{
                                'background-image': 'url(' + user.imagen + ')',
                                'background-position': 'center center',
                              }"
                            ></div>
                            <div
                              class="v-responsive__content"
                              style="width: 1229px"
                            ></div>
                          </div>
                          <v-icon v-else>mdi-account</v-icon>
                        </v-avatar>
                        Ver mi perfil
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-btn
                        depressed
                        color="primary"
                        class="ml-lg-5 ml-md-5 ml-0"
                        @click="showSearchProfile = true"
                        
                      >
                      <v-icon
                        left
                      >
                        mdi-account-search
                      </v-icon>
                        Buscar perfil
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-btn
                        depressed
                        color="warning"
                        @click="verAll()"
                        class="ml-lg-5 ml-md-5 ml-0"
                      >
                        {{ getAll == 1 ? "Interesante para mi" : "Ver todo" }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <br />
          <div class="text-center">
            <v-progress-circular
              indeterminate
              v-if="loading"
              color="primary"
            ></v-progress-circular>
          </div>
          <br />
          <v-divider></v-divider>
          <br />
          <v-container>
            <masonry
              :gutter="{ default: '30px', 700: '15px' }"
              :cols="{ default: 2, 1000: 2, 700: 1, 500: 1 }"
            >
              <v-card
                v-for="item in publicationsFiltered"
                :key="item.id"
                class="mt-2 mb-2"
                elevation="1"
                flat
              >
              <div v-if="item.create_by_client == true && item.alumno_id == user.IDStB">

                <v-list-item two-line>
                  <v-list-item-icon>
                    <v-avatar
                      size="50"
                      color="#8fc6dc"
                      style="cursor: pointer"
                    >
                      <v-img :src="item.cliente.empleado.imagen"></v-img>
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="text-h6">
                      {{ item.cliente.empleado.nombres }}
                      {{ item.cliente.empleado.apellidos }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <v-rating
                        :value="item.cliente.puntaje"
                        color="amber"
                        dense
                        half-increments
                        readonly
                        size="14"
                      ></v-rating>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle
                      ><small
                        >Hace {{ gettime(item.updated_at) }}</small
                      ></v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>

                <v-carousel
                  hide-delimiters
                  :show-arrows="
                    item.images.length >= 2 ||
                    (item.images.length == 1 && item.video)
                      ? true
                      : false
                  "
                  v-if="item.images.length >= 2 || item.video"
                  height="300"
                >
                  <v-carousel-item
                    v-for="(image, j) in item.images.filter((d) => {
                      return d.active == 1;
                    })"
                    :key="j"
                    :src="image.image"
                    @click="openPublication(item)"
                  ></v-carousel-item>
                  <v-carousel-item v-if="item.video">
                    <iframe
                      v-if="item.video"
                      width="100%"
                      height="300"
                      :src="item.video"
                      frameborder="0"
                      allow="autoplay; encrypted-media"
                      allowfullscreen
                      class="mt-10"
                    ></iframe>
                  </v-carousel-item>
                </v-carousel>

                <v-img
                  @click="openPublication(item)"
                  v-if="item.images.length == 1"
                  :src="item.images[0].image"
                ></v-img>
                <v-card-text
                  style="color: #424242"
                  v-html="item.contentHtml.substring(0, 150)"
                >
                </v-card-text>
                <v-card-text style="color: #424242" class="mt-0 pt-0 pb-0">
                  <small
                    @click="openPublication(item)"
                    style="text-decoration: underline; cursor: pointer"
                    >Ver publicación</small
                  >
                </v-card-text>
                <v-card-actions style="padding-left: 20px">
                  <v-avatar
                    size="30"
                    :color="getColor()"
                    v-for="(like, i) in item.likes.slice(0, 5)"
                    :key="i"
                    style="margin-left: -15px; cursor: pointer"
                    @click="openProfile(like.alumno.IDStB, 'alumno')"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-img
                          v-bind="attrs"
                          v-on="on"
                          :src="like.alumno.imagen"
                          v-if="like.alumno.imagen"
                        ></v-img>
                        <v-icon v-bind="attrs" v-on="on" v-else
                          >mdi-account</v-icon
                        >
                      </template>
                      <span
                        >{{ like.alumno.Nombres }}
                        {{ like.alumno.Apellidos }}</span
                      >
                    </v-tooltip>
                  </v-avatar>

                  <v-avatar
                    size="30"
                    :color="getColor()"
                    v-for="(like, i) in item.likes_profesor.slice(0, 5)"
                    :key="i + 'profesor'"
                    style="margin-left: -15px; cursor: pointer"
                    @click="openProfile(like.profesor.IDStB, 'profesor')"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-img
                          v-bind="attrs"
                          v-on="on"
                          :src="like.profesor.empleado.imagen"
                          v-if="like.profesor.empleado.imagen"
                        ></v-img>
                        <v-icon v-bind="attrs" v-on="on" v-else
                          >mdi-account</v-icon
                        >
                      </template>
                      <span
                        >{{ like.profesor.empleado.nombres }}
                        {{ like.profesor.empleado.apellidos }}</span
                      >
                    </v-tooltip>
                  </v-avatar>

                  <v-spacer></v-spacer>

                  <div v-if="item.alumno != null">

                    <v-btn
                    icon
                    @click="remove(item.id, index)"
                    v-if="
                      item.alumno.IDStB == user.IDStB &&
                      item.type_user == user.tipoUsuario
                    "
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    @click="edit(item, index)"
                    v-if="
                      item.alumno.IDStB == user.IDStB &&
                      item.type_user == user.tipoUsuario
                    "
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>

                  </div>
                  <div v-else-if="item.profesor != null">

                    <v-btn
                    icon
                    @click="remove(item.id, index)"
                    v-if="
                      item.profesor.IDStB == user.IDStB &&
                      item.type_user == user.tipoUsuario
                    "
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    @click="edit(item, index)"
                    v-if="
                      item.profesor.IDStB == user.IDStB &&
                      item.type_user == user.tipoUsuario
                    "
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>

                  </div>

                  

                  <v-btn
                    icon
                    @click="addLike(item)"
                    v-if="
                      item.likes.filter((d) => {
                        return (
                          d.alumno.IDStB == user.IDStB &&
                          d.type_user == user.tipoUsuario
                        );
                      }).length == 0 &&
                      item.likes_profesor.filter((d) => {
                        return (
                          d.profesor.IDStB == user.IDStB &&
                          d.type_user == user.tipoUsuario
                        );
                      }).length == 0
                    "
                  >
                    <v-icon color="red">mdi-heart-outline</v-icon
                    ><small>{{
                      item.likes.length + item.likes_profesor.length
                    }}</small>
                  </v-btn>
                  <v-btn icon v-else @click="removeLike(item)">
                    <v-icon color="red">mdi-heart</v-icon
                    ><small>{{
                      item.likes.length + item.likes_profesor.length
                    }}</small>
                  </v-btn>

                  <v-btn icon class="ml-5" @click="openPublication(item)">
                    <v-icon>mdi-comment-outline</v-icon
                    ><small>{{
                      item.comments.length + item.comments_profesor.length
                    }}</small>
                  </v-btn>
                </v-card-actions>

              </div>

              <div v-else-if='item.create_by_client == false' >

                <v-list-item v-if="item.alumno != null" two-line>
                  <v-list-item-icon>
                    <v-avatar
                      size="50"
                      color="#8fc6dc"
                      style="cursor: pointer"
                      title="Ver perfil"
                      @click="openProfile(item.alumno.IDStB, 'alumno')"
                    >
                      <v-img :src="item.alumno.imagen"></v-img>
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="text-h6">
                      {{ item.alumno.Nombres }} {{ item.alumno.Apellidos }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <v-rating
                        :value="item.alumno.puntaje"
                        color="amber"
                        dense
                        half-increments
                        readonly
                        size="14"
                      ></v-rating>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle
                      ><small
                        >Hace {{ gettime(item.updated_at) }}</small
                      ></v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-else two-line>
                  <v-list-item-icon>
                    <v-avatar
                      size="50"
                      color="#8fc6dc"
                      style="cursor: pointer"
                      title="Ver perfil"
                      @click="openProfile(item.profesor.IDStB, 'profesor')"
                    >
                      <v-img :src="item.profesor.empleado.imagen"></v-img>
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="text-h6">
                      {{ item.profesor.empleado.nombres }}
                      {{ item.profesor.empleado.apellidos }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <v-rating
                        :value="item.profesor.puntaje"
                        color="amber"
                        dense
                        half-increments
                        readonly
                        size="14"
                      ></v-rating>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle
                      ><small
                        >Hace {{ gettime(item.updated_at) }}</small
                      ></v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>

                <v-carousel
                  hide-delimiters
                  :show-arrows="
                    item.images.length >= 2 ||
                    (item.images.length == 1 && item.video)
                      ? true
                      : false
                  "
                  v-if="item.images.length >= 2 || item.video"
                  height="300"
                >
                  <v-carousel-item
                    v-for="(image, j) in item.images.filter((d) => {
                      return d.active == 1;
                    })"
                    :key="j"
                    :src="image.image"
                    @click="openPublication(item)"
                  ></v-carousel-item>
                  <v-carousel-item v-if="item.video">
                    <iframe
                      v-if="item.video"
                      width="100%"
                      height="300"
                      :src="item.video"
                      frameborder="0"
                      allow="autoplay; encrypted-media"
                      allowfullscreen
                      class="mt-10"
                    ></iframe>
                  </v-carousel-item>
                </v-carousel>

                <v-img
                  @click="openPublication(item)"
                  v-if="item.images.length == 1"
                  :src="item.images[0].image"
                ></v-img>
                <v-card-text
                  style="color: #424242"
                  v-html="item.contentHtml.substring(0, 150)"
                >
                </v-card-text>
                <v-card-text style="color: #424242" class="mt-0 pt-0 pb-0">
                  <small
                    @click="openPublication(item)"
                    style="text-decoration: underline; cursor: pointer"
                    >Ver publicación</small
                  >
                </v-card-text>
                <v-card-actions style="padding-left: 20px">
                  <v-avatar
                    size="30"
                    :color="getColor()"
                    v-for="(like, i) in item.likes.slice(0, 5)"
                    :key="i"
                    style="margin-left: -15px; cursor: pointer"
                    @click="openProfile(like.alumno.IDStB, 'alumno')"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-img
                          v-bind="attrs"
                          v-on="on"
                          :src="like.alumno.imagen"
                          v-if="like.alumno.imagen"
                        ></v-img>
                        <v-icon v-bind="attrs" v-on="on" v-else
                          >mdi-account</v-icon
                        >
                      </template>
                      <span
                        >{{ like.alumno.Nombres }}
                        {{ like.alumno.Apellidos }}</span
                      >
                    </v-tooltip>
                  </v-avatar>

                  <v-avatar
                    size="30"
                    :color="getColor()"
                    v-for="(like, i) in item.likes_profesor.slice(0, 5)"
                    :key="i + 'profesor'"
                    style="margin-left: -15px; cursor: pointer"
                    @click="openProfile(like.profesor.IDStB, 'profesor')"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-img
                          v-bind="attrs"
                          v-on="on"
                          :src="like.profesor.empleado.imagen"
                          v-if="like.profesor.empleado.imagen"
                        ></v-img>
                        <v-icon v-bind="attrs" v-on="on" v-else
                          >mdi-account</v-icon
                        >
                      </template>
                      <span
                        >{{ like.profesor.empleado.nombres }}
                        {{ like.profesor.empleado.apellidos }}</span
                      >
                    </v-tooltip>
                  </v-avatar>

                  <v-spacer></v-spacer>

                  <div v-if="item.alumno != null">

                    <v-btn
                    icon
                    @click="remove(item.id, index)"
                    v-if="
                      item.alumno.IDStB == user.IDStB &&
                      item.type_user == user.tipoUsuario
                    "
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    @click="edit(item, index)"
                    v-if="
                      item.alumno.IDStB == user.IDStB &&
                      item.type_user == user.tipoUsuario
                    "
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>

                  </div>
                  <div v-else-if="item.profesor != null">

                    <v-btn
                    icon
                    @click="remove(item.id, index)"
                    v-if="
                      item.profesor.IDStB == user.IDStB &&
                      item.type_user == user.tipoUsuario
                    "
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    @click="edit(item, index)"
                    v-if="
                      item.profesor.IDStB == user.IDStB &&
                      item.type_user == user.tipoUsuario
                    "
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>

                  </div>

                  

                  <v-btn
                    icon
                    @click="addLike(item)"
                    v-if="
                      item.likes.filter((d) => {
                        return (
                          d.alumno.IDStB == user.IDStB &&
                          d.type_user == user.tipoUsuario
                        );
                      }).length == 0 &&
                      item.likes_profesor.filter((d) => {
                        return (
                          d.profesor.IDStB == user.IDStB &&
                          d.type_user == user.tipoUsuario
                        );
                      }).length == 0
                    "
                  >
                    <v-icon color="red">mdi-heart-outline</v-icon
                    ><small>{{
                      item.likes.length + item.likes_profesor.length
                    }}</small>
                  </v-btn>
                  <v-btn icon v-else @click="removeLike(item)">
                    <v-icon color="red">mdi-heart</v-icon
                    ><small>{{
                      item.likes.length + item.likes_profesor.length
                    }}</small>
                  </v-btn>

                  <v-btn icon class="ml-5" @click="openPublication(item)">
                    <v-icon>mdi-comment-outline</v-icon
                    ><small>{{
                      item.comments.length + item.comments_profesor.length
                    }}</small>
                  </v-btn>
                </v-card-actions>

              </div>
              

              
              </v-card>
            </masonry>
          </v-container>
          <v-row>
            <p
              class="
                m-10
                p-5
                preview
                d-flex
                align-center
                justify-center
                pa-4
                mx-auto
              "
              v-if="current_page == last_page"
            >
              No hay mas publicaciones para mostrar
            </p>
          </v-row>
        </div>
      </v-col>
      <ModalCustom
        :show="show"
        @update="onUpdateShow"
        :content="contentAlert"
        :type="typeAlert"
      />
      <Publication
        :showDialog="showPublication"
        @updatepublication="onUpdateShowPublication"
        :publication="publicationSelected"
        :followings="followings"
      />
      <SearchProfile
        :showDialog="showSearchProfile"
        @updatepublication="onUpdateShowSearch"
        
      />
      <!-- </v-row> -->
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";
import ModalCustom from "../../components/ModalCustom";
import Publication from "../../components/Publication";
import SearchProfile from "../../components/SearchProfile";
//import VueMasonryWall from 'vue-masonry-wall';
//import { VueMasonryPlugin } from "vue-masonry";
//import masonry from 'vue-masonry-css'
//import { VueAtTextarea } from 'vue-at-textarea'

import moment from "moment";
import { VEmojiPicker } from "v-emoji-picker";
import { Mentionable } from "vue-mention";

moment.locale("es");
export default {
  name: "Publicacion",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
    ModalCustom,
    Publication,
    VEmojiPicker,
    Mentionable,
    SearchProfile
  },

  data: () => ({
    title: "Publicaciones",
    content: "",
    content2: "",
    selection: 1,
    show: false,
    contentAlert: "",
    typeAlert: "modal-info",
    showPublication: false,
    publications: [],
    imageSelected: "",
    publicationSelected: null,
    loading: false,
    url: null,
    files: [],
    limit: 10,
    video: null,
    current_page: 0,
    last_page: -1,
    action: "add",
    publication: null,
    current_index: null,
    images_deleted: [],
    active: 1,
    showEmojis: false,
    followers: [],
    followings: [],
    options: {
      width: 300,
      padding: {
        default: 12,
        5: 3,
        6: 3,
      },
    },
    selecteds: [],
    items: [
      {
        value: "akryum",
        firstName: "Guillaume",
        label: "Guillaumess",
      },
      {
        value: "posva",
        firstName: "Eduardo",
        label: "Eduardooo",
      },
      {
        value: "atinux",
        firstName: "Sébastien",
        label: "Sébastiennn",
      },
    ],
    getAll: 0,
    usuarioBorrado: "",
    regex: "",
    showSearchProfile:false
  }),

  mounted() {
    if(this.$store.getters.user.borrado == 1 ||  this.$store.getters.user.alumno_mora ==  true){
      this.$router.push({
          name: "Home"
        });
    }
    //this.$refs.textarea.input.focus()
    let id = this.$route.params.id;
    this.usuarioBorrado = this.user.borrado;
    this.getUserLogged();
    this.verifierStatus();
    this.getPublications();
    window.addEventListener("scroll", this.onScroll);
    if (id) {
      this.getPublication(id);
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    publicationsFiltered() {
      const result = [];
      for (const p of this.publications) {
        
        if(p.alumno.shadowban == 0 || p.alumno.IDStB == this.user.IDStB){
          p.contentHtml = p.content;
          if (p.taggeds && p.taggeds.length > 0) {
            p.taggeds.forEach((val) => {
              let t = new Date().getTime();
              p.contentHtml = p.contentHtml.replace(
                val.shortName.trim(),
                '<a class="tagged" href="profile/' +
                  val.IDStB +
                  "?t=" +
                  t +
                  '">' +
                  val.shortName.trim() +
                  "</a>"
              );
            });
          }
          result.push(p);
        }
        
      }
      
      // eslint-disable-next-line
      var parse_url = /https?:\/\/([a-zA-Z0-9.-]+(?:\/[a-zA-Z0-9.%:_()+=-]*)*(?:\?[a-zA-Z0-9.%:_+&/()=-]*)?(?:#[a-zA-Z0-9.%:()_+=-]*)?)/g;

      for (const p of this.publications) {
        if(p.alumno.shadowban == 0 || p.alumno.IDStB == this.user.IDStB){
          if (p.contentHtml.length > 0) {
            // eslint-disable-next-line
            
            let textToTranform = p.contentHtml.split(' ');
            let finalText = '';
            let index = 0;

            for (const i of textToTranform) {
              finalText+= index == 0 ? '' : ' ';

              if(parse_url.exec(i)) finalText+= '<a target="_blank" href="'+i+'">"'+i+'"</a>';
              else finalText+= i;
              
              index++;
            }

            p.contentHtml = finalText;
          }
          result.push(p);
        }
      }
      return result;
    }
  },
  methods: {
    selectItem(item) {
      this.selecteds.push(item);
    },
    async getUserLogged() {
      this.$API
        .get({
          url: "alumno/getAlumno",
        })
        .then((res) => {
          console.log(res);

          res.followings.forEach((val) => {
            let n = val.following.Nombres.trim().replace(" ", ".");
            let i = val.following.imagen
              ? val.following.imagen
              : "https://icons.iconarchive.com/icons/papirus-team/papirus-status/256/avatar-default-icon.png";
            this.followings.push({
              Avatar: i,
              value: n,
              id: val.following.IDStB.toString(),
            });
          });
          console.log(this.followings);
        });
    },
    async verifierStatus() {
      this.$API
        .get({
          url: "publications-service-status",
        })
        .then((res) => {
          this.active = res;
        });
    },
    onFileChange(e) {
      let all = e.target.files;
      let r = this.files;
      [all].forEach((val) => {
        if (r.length < this.limit) {
          for (const item of val) {
            if (item.type.match("image.*")) {
              item.url = URL.createObjectURL(item);
              r.push(item);
            }
          }
        }
      });
      this.files = Array.from(r);
      if (this.limit == this.files.length) {
        this.contentAlert =
          "El número máximo de imágenes por publicación es " + this.limit;
        this.show = true;
      }
    },
    gettime(date_publish) {
      let current_date = moment();
      let published_date = moment(date_publish);
      return moment.duration(current_date - published_date).humanize();
    },

    onVideoChange(e) {
      let v = e.target.files[0];
      console.log('Este es el video ------------------',v)
      if (v.type.match("video.*")) {
        v.uri = URL.createObjectURL(v);
        this.video = v;
      } else {
        this.typeAlert = "info";
        this.contentAlert = "Agrega un formato válido de video";
        this.show = true;
      }
    },
    async uploadFilesEvent() {
      this.$refs.fileInput.click();
    },
    async getPublications(reload = false) {
      if (this.current_page !== this.last_page || reload) {
        // this.loading = true;
        this.current_page++;
        this.$API
          .get(
            {
              url:
                "publications?page=" +
                this.current_page +
                "&getAll=" +
                this.getAll,
            },
            false
          )
          .then((res) => {
            if (reload) {
              this.publications = res.data;
            } else {
              this.publications.push(...res.data);
            }

            this.current_page = res.current_page;
            this.last_page = res.last_page;
            // this.loading = false;
          });
      }
    },
    async getPublication(id) {
      this.$API
        .get({
          url: "publications/" + id,
        })
        .then((res) => {
          console.log('resss', res)
          this.openPublication(res);
        });
    },
    verAll() {
      this.getAll = this.getAll == 0 ? 1 : 0;
      this.current_page = 0;
      this.getPublications(true);
    },

    async test() {
      this.$API
        .get({
          url: "notifications?type=message",
        })
        .then((res) => {
          console.log(res);
        });
    },
    async test_() {
      this.$API
        .get({
          url: "notifications-total",
        })
        .then((res) => {
          console.log(res);
        });
    },
    async test2() {
      await this.$API
        .post({
          url: "notifications-reset",
          data: { type: "post" },
        })
        .then((res) => {
          console.log(res);
        });
    },
    async uploadVideoEvent() {
      this.$refs.fileInputVideo.click();
    },
    openPublication(item) {
      console.log(item)
      this.showPublication = true;
      this.publicationSelected = item;
    },
    onUpdateShow(newData) {
      this.show = newData;
    },
    onUpdateShowPublication(newData) {
      this.showPublication = newData;
    },
    onUpdateShowSearch(newData) {
      this.showSearchProfile = newData;
    },
    async addPost() {
      if (this.content) {
        var formData = new FormData();
        formData.append("content", this.content);
        if (this.files.length > 0) {
          formData.append("cantidadImagen", this.files.length);
          let i = 0;
          for (let file of this.files) {
            formData.append(`imagen_${i}`, file, file.name);
            i++;
          }
        }
        if (this.video) {
          formData.append("video", this.video);
        }

        if (this.selecteds.length > 0) {
          let taggeds = new Array();
          this.selecteds.forEach((val) => {
            if (this.content.includes(val.value)) {
              taggeds.push(val.id);
            }
          });
          formData.append("tagged", taggeds.join(","));
        }
        console.log('JUSTO ANTES DE USARLO- ------',formData.get('video'));

        await this.$API
          .post({
            url: "publications",
            data: formData,
          })
          .then((res) => {
            this.publications.unshift(res);
            this.content = "";
            this.files = [];
            this.video = null;
          });
      } else {
        this.contentAlert =
          "Para poder publicar su post debes ingresar un texto";
        this.show = true;
      }
    },
    async editPost() {
      if (this.content) {
        var formData = new FormData();
        formData.append("content", this.content);
        if (this.files.length > 0) {
          formData.append("cantidadImagen", this.files.length);
          let i = 0;
          for (let file of this.files) {
            if (!file.id) {
              formData.append(`imagen_${i}`, file, file.name);
              i++;
            }
          }
        }
        if (this.images_deleted.length > 0) {
          formData.append("images_delete", this.images_deleted);
        }
        if (this.video) {
          formData.append("video", this.video);
        }
        if (this.taggeds && this.taggeds.length > 0) {
          formData.append("tagged", this.taggeds.join(","));
        }
        await this.$API
          .post({
            url: "publications/" + this.publication.id,
            data: formData,
          })
          .then((res) => {
            console.log(res);
            this.clear();
            this.current_page = 0;
            this.getPublications(true);
          });
      } else {
        this.contentAlert =
          "Para poder publicar su post debes ingresar un texto";
        this.show = true;
      }
    },
    clear() {
      this.publication = null;
      this.content = null;
      this.images_deleted = [];
      this.files = [];
      this.video = null;
      this.action = "add";
    },
    cancel() {
      this.clear();
      this.current_page = 0;
      this.getPublications(true);
    },
    async remove(id, index) {
      if (
        confirm(
          "¿Estas seguro de querer borrar la publicacion, ya no se podrá recuperar nuevamente?"
        )
      ) {
        await this.$API
          .delete({
            url: "publications/" + id,
            data: {},
          })
          .then((res) => {
            if (res) {
              this.publications.splice(index, 1);
            }
          });
      }
    },
    edit(item, index) {
      window.scrollTo(0, 0);
      this.action = "edit";
      this.content = item.content;
      this.files = item.images;
      this.video = item.video;
      this.publication = item;
      this.current_index = index;
      this.images_deleted = [];
      console.log(this.images_deleted);
    },
    async addLike(item) {
      await this.$API
        .post({
          url: "publications-like",
          data: {
            publication_id: item.id,
          },
        })
        .then((res) => {
          if (res.alumno != null) {
            item.likes.push(res);
          } else {
            item.likes_profesor.push(res);
          }
        });
    },

    async removeLike(item) {
      await this.$API
        .delete({
          url: "publications-like-bypost/" + item.id,
        })
        .then((res) => {
          if (res) {
            item.likes = item.likes.filter((d) => {
              return d.alumno.IDStB != this.user.IDStB;
            });
            item.likes_profesor = item.likes_profesor.filter((d) => {
              return d.profesor.IDStB != this.user.IDStB;
            });
          }
        });
    },
    deleteFileThumnail(index, id) {
      this.files.splice(index, 1);
      if (id) {
        this.images_deleted.push(id);
        console.log(this.images_deleted);
      }
    },
    onScroll() {
      if (
        document.body.scrollHeight - window.innerHeight - window.top.scrollY <=
        500
      ) {
        this.getPublications();
      }
    },
    selectEmoji(emoji) {
      console.log(emoji);
      this.content += emoji.data;
    },
    openProfile(id, tipo_usuario) {
      this.$router.push({
        name: "Profile",
        params: {
          id: id,
          tipo_usuario: tipo_usuario,
        },
        query: {
          t: new Date().getTime(),
        },
      });
    },
    append() {
      if (this.publications.length > 100) {
        return;
      }
      this.getPublications();
    },
    getColor() {
      let colors = ["#a7ba38", "#095da1", "#e79029", "#dd404a", "#8fc6dc"];
      let min = 0;
      var max = colors.length;
      var random = Math.floor(Math.random() * (max - min)) + min;
      return colors[random];
    },
  },
};
</script>

<style>
  .v-card__subtitle,
  .v-card__text {
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 0.95rem !important;
    letter-spacing: 0.007143em;
  }
  .preview {
    margin: 10px;
  }
  .preview img {
    margin: 5px;
    max-width: 90%;
  }
  .v-chip.v-size--default {
    height: auto !important;
  }
  /* #EmojiPicker {
    width: 380px;
    background-color: white;
    border: none;
  } */
  .item {
    padding: 16px 24px;
    border-radius: 3px;
    background: #f5f5f5;
  }
  .v-carousel__item .v-image__image--cover {
    background-size: contain;
  }
  .atwho-ul {
    padding-left: 0 !important;
  }
  /* .v-application--is-ltr
    .v-textarea.v-text-field--enclosed
    .v-text-field__slot
    textarea {
    visibility: hidden;
  } */
  .tagged {
    font-weight: bold;
    text-decoration: none;
  }
  .mention-item {
    padding: 4px 10px;
    border-radius: 4px;
    font-family: "Roboto", sans-serif !important;
    font-size: 14px;
  }

  .mention-selected {
    background: #125ea5;
    color: white;
  }
  .tooltip {
    display: block !important;
    z-index: 10000;
  }
  .tooltip .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }
  .tooltip .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }
  .tooltip[x-placement^="top"] {
    margin-bottom: 5px;
  }
  .tooltip[x-placement^="top"] .tooltip-arrow {
    border-width: 5px 5px 0 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    bottom: -5px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
  }
  .tooltip[x-placement^="bottom"] {
    margin-top: 5px;
  }
  .tooltip[x-placement^="bottom"] .tooltip-arrow {
    border-width: 0 5px 5px 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-top-color: transparent !important;
    top: -5px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
  }
  .tooltip[x-placement^="right"] {
    margin-left: 5px;
  }
  .tooltip[x-placement^="right"] .tooltip-arrow {
    border-width: 5px 5px 5px 0;
    border-left-color: transparent !important;
    border-top-color: transparent !important;
    border-bottom-color: transparent !important;
    left: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
  }
  .tooltip[x-placement^="left"] {
    margin-right: 5px;
  }
  .tooltip[x-placement^="left"] .tooltip-arrow {
    border-width: 5px 0 5px 5px;
    border-top-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    right: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
  }
  .tooltip.popover .popover-inner {
    background: #f9f9f9;
    color: black;
    padding: 12px;
    border-radius: 5px;
    box-shadow: 0 5px 12px rgba(0, 0, 0, 0.1);
  }
  .tooltip.popover .popover-arrow {
    border-color: #f9f9f9;
  }
  .tooltip[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
  }
  .tooltip[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
  }
</style>
